// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo_picture {
    max-width: 100%;
}

.home_button {
    font-size: 1.5em;
    display: block;
    padding: 10px;
    font-weight: normal;
    color: var(--weiss);
    border-radius: 10px;
    margin: 10px 0;
    text-transform: none;
}

.notfallnummern-strip {
    padding: 10px 0;
}

.bereich-auswahl-title {
    font-family: 'Circular', sans-serif;
    color: var(--hellblau);
    font-size: 0.9em;
    margin: 15px 0;
}

.notfallnummern-link {
    color: var(--blutorange);
    text-decoration: underline;
    text-underline-offset: 4px;
    font-weight: normal;
}

.bereich-auswahl {
    font-size: 1.5em;
    display: block;
    font-weight: normal;
    color: var(--weiss);
    border-radius: 10px;
    text-transform: none;
}

.bereich-auswahl_button {
    display: block;
    padding: 10px;
    font-weight: normal;
    color: var(--weiss);
    border-radius: 10px;
    margin: 10px 0;
    text-transform: none;
}

.bereich-auswahl_button:nth-of-type(1) {
    background-color: var(--dunkelgruen);
}

.bereich-auswahl_button:nth-of-type(2) {
    background-color: var(--orange);
}

.bereich-auswahl_button:nth-of-type(3) {
    background-color: var(--gelb);
}

.bereich-auswahl_button:nth-of-type(4) {
    background-color: var(--mittelblau);
}
`, "",{"version":3,"sources":["webpack://./src/components/home/Home.css"],"names":[],"mappings":"AAGA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["@import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n\n\n.logo_picture {\n    max-width: 100%;\n}\n\n.home_button {\n    font-size: 1.5em;\n    display: block;\n    padding: 10px;\n    font-weight: normal;\n    color: var(--weiss);\n    border-radius: 10px;\n    margin: 10px 0;\n    text-transform: none;\n}\n\n.notfallnummern-strip {\n    padding: 10px 0;\n}\n\n.bereich-auswahl-title {\n    font-family: 'Circular', sans-serif;\n    color: var(--hellblau);\n    font-size: 0.9em;\n    margin: 15px 0;\n}\n\n.notfallnummern-link {\n    color: var(--blutorange);\n    text-decoration: underline;\n    text-underline-offset: 4px;\n    font-weight: normal;\n}\n\n.bereich-auswahl {\n    font-size: 1.5em;\n    display: block;\n    font-weight: normal;\n    color: var(--weiss);\n    border-radius: 10px;\n    text-transform: none;\n}\n\n.bereich-auswahl_button {\n    display: block;\n    padding: 10px;\n    font-weight: normal;\n    color: var(--weiss);\n    border-radius: 10px;\n    margin: 10px 0;\n    text-transform: none;\n}\n\n.bereich-auswahl_button:nth-of-type(1) {\n    background-color: var(--dunkelgruen);\n}\n\n.bereich-auswahl_button:nth-of-type(2) {\n    background-color: var(--orange);\n}\n\n.bereich-auswahl_button:nth-of-type(3) {\n    background-color: var(--gelb);\n}\n\n.bereich-auswahl_button:nth-of-type(4) {\n    background-color: var(--mittelblau);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
